import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const baseClasses = `
    relative inline-flex items-center justify-center px-8 py-4 
    text-lg font-bold text-[#0a0e1a] uppercase tracking-wide
    bg-gradient-to-r from-[#c9a84c] via-[#d4af37] to-[#c9a84c]
    rounded-lg shadow-[0_0_20px_rgba(212,175,55,0.3)]
    transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.6)]
    hover:scale-[1.02] active:scale-[0.98]
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-387">{children}</span>
      <div className="absolute inset-0 rounded-lg bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-388" />
    </>;
  if (href) {
    const isExternal = href.startsWith('http');
    return <motion.a href={href} className={baseClasses} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={onClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-389">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={baseClasses} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-390">
      {content}
    </motion.button>;
}